import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import SelectLocaleDropdown from '../../ui/SelectLocaleDropdown';
import {setLocale} from '../../../redux/actions/localeActions';
import {AppDispatch, RootState} from '../../../../store/configureStore';
import {AllowedLocale} from '../../../redux/localeActionTypes';

export interface LocaleSelectorProps {
  /** For testing purposes */
  inputId?: string
}

const LocaleSelector = (props: LocaleSelectorProps) => {
  const dispatch: AppDispatch = useDispatch();
  const currentLocale = useSelector((state: RootState) => state.i18n.locale);
  const handleChange = (value: AllowedLocale) => dispatch(setLocale(value))

  return (
    <SelectLocaleDropdown
      current={currentLocale}
      onChange={handleChange}
      {...props}
    />
  );
};

export default LocaleSelector;
